import '../assets/font/Inter-Bold-normal';
import '../assets/font/Inter-Light-normal';
import '../assets/font/Inter-Regular-normal';
import '../assets/font/Inter-Medium-normal';
import '../assets/font/Inter-SemiBold-normal';

export default {
  methods: {
    async addHeaderMontlyPDF(doc) {
      // Adiciona a logomarca
      // doc.setLineWidth(0.4);
      // let response = await fetch(logomarcaImageUrl);
      // let blob = await response.blob();
      // let blobUrl = URL.createObjectURL(blob);
      // doc.addImage(blobUrl, 'JPEG', x + 10, y + 5, 20, 20);

      // // Adiciona a logotipo
      // response = await fetch(logotipoImageUrl);
      // blob = await response.blob();
      // blobUrl = URL.createObjectURL(blob);
      // doc.addImage(blobUrl, 'JPEG', x + 5, y + 30, 35, 4);

      // // Libera a URL do Blob
      // URL.revokeObjectURL(blobUrl);
      // Define a fonte para o nome da empresa (mais escura e em negrito)

      doc.setFont('Inter-Regular');

      return doc;
    },

    async addTableMontlyPDF(doc, harvests, houses, month, year) {
      // const largura = 190; // Largura da borda
      const posicaoAtual = 90; // Posição atual do cursor
      // const alturaTotal = 290; // Altura total da tabela
      // const espacoRestante = alturaTotal - posicaoAtual; // Espaço restante para a tabela
      doc.setLineWidth(0.5);

      // Adicionar o retângulo ao documento com a cor especificada
      doc.setDrawColor(182, 182, 182);
      // doc.rect(10, posicaoAtual, largura, espacoRestante); // Desenhar o retângulo

      const tableData = [
        ['Bandeja', 'Quilos', 'Total em KG', 'Média KG/Dia'],
        [],
      ];

      const totalKG = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_kg,
        0
      );

      const totalBandejas = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_plate,
        0
      );

      const total = totalKG + totalBandejas * 0.2;

      const numDias = new Date(year, month, 0).getDate();

      const media = total / numDias;

      tableData[1].push(
        totalBandejas,
        totalKG,
        total.toFixed(2),
        media.toFixed(2)
      );

      const tableY = posicaoAtual + 5; // Posição Y da tabela

      // Tabela de dados gerais
      // doc.setFont('Inter-SemiBold');
      // doc.setFontSize(12);
      // const text = 'Dados Gerais';
      // doc.text(15, posicaoAtual + 7, text);

      doc.autoTable({
        head: [['DADOS GERAIS']],
        startY: tableY,
        theme: 'plain',
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        tableWidth: 31.5,
      });

      doc.autoTable({
        head: [tableData[0]], // Cabeçalho da tabela (em um array)
        body: tableData.slice(1), // Dados da tabela (excluindo o cabeçalho)
        startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
        theme: 'plain', // Estilo da tabela (opcional)
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 12,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 10, // Altura mínima das células do cabeçalho
          minCellWidth: 15, // Largura mínima das células do cabeçalho
          cellWidth: 'wrap',
        },
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 20, // Altura mínima das células do cabeçalho
          minCellWidth: 15, // Largura mínima das células do cabeçalho
          cellWidth: 'wrap',
        },
        tableWidth: 180,
      });

      // Tabela de dados mensais
      const tableData2 = [[], [], []];

      houses.forEach((house) => {
        const casa = {
          content: `${house.house_name}`,
          colSpan: 2,
          styles: { halign: 'center' },
        };

        const valorBDJ = harvests.reduce((acc, harvest) => {
          if (harvest.houses.id === house.id) {
            return acc + harvest.harvest_quantity_plate;
          }
          return acc;
        }, 0);

        const valorKG = harvests.reduce((acc, harvest) => {
          if (harvest.houses.id === house.id) {
            return acc + harvest.harvest_quantity_kg;
          }
          return acc;
        }, 0);
        tableData2[0].push(casa);
        tableData2[1].push('Bandeja', 'Quilos');
        tableData2[2].push(valorBDJ, valorKG);
      });

      const tableY2 = doc.lastAutoTable.finalY + 10; // Posição Y da tabela
      doc.autoTable({
        head: [['MENSAL']],
        startY: tableY2,
        theme: 'plain',
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        tableWidth: 31.5,
      });
      doc.autoTable({
        head: [], // Cabeçalho vazio para reservar espaço
        body: tableData2, // Dados da tabela
        startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
        theme: 'plain', // Estilo da tabela (opcional)
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 4 : 6,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 10,
          cellWidth: 'auto',
        },
        tableWidth: 180,
      });

      const tableY3 = doc.lastAutoTable.finalY + 10; // Posição Y da tabela

      const headData = [['DATA', 'TURNO'], [{ content: '', colSpan: 2 }]];

      houses.forEach((house) => {
        const casa = {
          content: `${house.house_name.toUpperCase()}`,
          colSpan: 2,
          styles: { halign: 'center' },
        };
        headData[0].push(casa);

        headData[1].push('BDJ', 'KG');
      });

      const nomeMonth = new Date(year, month - 1, 1)
        .toLocaleString('pt-br', {
          month: 'long',
        })
        .substring(0, 3)
        .toUpperCase();

      const diasDoMes = [];
      for (let i = 1; i <= numDias; i += 1) {
        const dia = i < 10 ? `0${i}\n${nomeMonth}` : `${i}\n${nomeMonth}`;
        diasDoMes.push(dia);
      }

      const tableData3 = [];

      diasDoMes.forEach((dia) => {
        const rowData = [
          {
            rowSpan: 2,
            styles: { halign: 'center' },
            content: dia,
          },
          'Manhã', // Coluna para "Manhã"
        ];
        const rowDataTarde = ['Tarde'];
        const diaAtual = parseFloat(dia);
        houses.forEach((house) => {
          harvests.forEach((harvest) => {
            const harvestDate = parseFloat(
              harvest.harvest_date.substring(8, 10)
            );
            if (harvestDate === diaAtual && house.id === harvest.houses.id) {
              if (harvest.shift === 'manhã') {
                rowData.push(harvest.harvest_quantity_plate);
                rowData.push(harvest.harvest_quantity_kg);
              }
              if (harvest.shift === 'tarde') {
                rowDataTarde.push(harvest.harvest_quantity_plate);
                rowDataTarde.push(harvest.harvest_quantity_kg);
              }
            }
          });
        });

        tableData3.push(rowData);
        tableData3.push(rowDataTarde); // Coluna para "Tarde"
      });

      doc.autoTable({
        head: headData, // Cabeçalho da tabela
        body: tableData3,
        startY: tableY3,
        theme: 'plain',
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 5 : 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 6 : 8,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        columnStyles: {
          0: { cellWidth: 15 }, // Defina a largura da primeira coluna (DATA)
          1: { cellWidth: 15 }, // Defina a largura da segunda coluna (TURNO)
        },
      });

      return doc;
    },

    async addTableYearPDF(doc, harvests, houses, year) {
      // const largura = 190; // Largura da borda
      const posicaoAtual = 90; // Posição atual do cursor
      // const alturaTotal = 290; // Altura total da tabela
      // const espacoRestante = alturaTotal - posicaoAtual; // Espaço restante para a tabela
      doc.setLineWidth(0.5);

      // Adicionar o retângulo ao documento com a cor especificada
      doc.setDrawColor(182, 182, 182);
      // doc.rect(10, posicaoAtual, largura, espacoRestante); // Desenhar o retângulo

      const tableData = [
        ['Bandeja', 'Quilos', 'Total em KG', 'Média KG/Dia'],
        [],
      ];

      const totalKG = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_kg,
        0
      );

      const totalBandejas = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_plate,
        0
      );

      const total = totalKG + totalBandejas * 0.2;

      const numDias = year % 4 === 0 ? 366 : 365;

      const media = total / numDias;

      tableData[1].push(
        totalBandejas,
        totalKG,
        total.toFixed(2),
        media.toFixed(2)
      );

      const tableY = posicaoAtual + 5; // Posição Y da tabela

      // Tabela de dados gerais
      // doc.setFont('Inter-SemiBold');
      // doc.setFontSize(12);
      // const text = 'Dados Gerais';
      // doc.text(15, posicaoAtual + 7, text);

      doc.autoTable({
        head: [['DADOS GERAIS']],
        startY: tableY,
        theme: 'plain',
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        tableWidth: 31.5,
      });

      doc.autoTable({
        head: [tableData[0]], // Cabeçalho da tabela (em um array)
        body: tableData.slice(1), // Dados da tabela (excluindo o cabeçalho)
        startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
        theme: 'plain', // Estilo da tabela (opcional)
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 12,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 10, // Altura mínima das células do cabeçalho
          minCellWidth: 15, // Largura mínima das células do cabeçalho
          cellWidth: 'wrap',
        },
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 20, // Altura mínima das células do cabeçalho
          minCellWidth: 15, // Largura mínima das células do cabeçalho
          cellWidth: 'wrap',
        },
        tableWidth: 180,
      });

      // Tabela de dados mensais
      const tableData2 = [[], [], []];

      houses.forEach((house) => {
        const casa = {
          content: `${house.house_name}`,
          colSpan: 2,
          styles: { halign: 'center' },
        };

        const valorBDJ = harvests.reduce((acc, harvest) => {
          if (harvest.houses.id === house.id) {
            return acc + harvest.harvest_quantity_plate;
          }
          return acc;
        }, 0);

        const valorKG = harvests.reduce((acc, harvest) => {
          if (harvest.houses.id === house.id) {
            return acc + harvest.harvest_quantity_kg;
          }
          return acc;
        }, 0);
        tableData2[0].push(casa);
        tableData2[1].push('Bandeja', 'Quilos');
        tableData2[2].push(valorBDJ, valorKG);
      });

      const tableY2 = doc.lastAutoTable.finalY + 10; // Posição Y da tabela
      doc.autoTable({
        head: [['TOTAL']],
        startY: tableY2,
        theme: 'plain',
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        tableWidth: 31.5,
      });
      doc.autoTable({
        head: [], // Cabeçalho vazio para reservar espaço
        body: tableData2, // Dados da tabela
        startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
        theme: 'plain', // Estilo da tabela (opcional)
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 4 : 6,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 10,
          cellWidth: 'auto',
        },
        tableWidth: 180,
      });

      const tableY3 = doc.lastAutoTable.finalY + 10; // Posição Y da tabela

      const headData = [
        [{ content: 'ANO', colSpan: 2 }],
        [{ content: '', colSpan: 2 }],
      ];

      houses.forEach((house) => {
        const casa = {
          content: `${house.house_name.toUpperCase()}`,
          colSpan: 2,
          styles: { halign: 'center' },
        };
        headData[0].push(casa);

        headData[1].push('BDJ', 'KG');
      });

      const diasDoMes = [];
      diasDoMes.push(year);

      const tableData3 = [];

      diasDoMes.forEach((y) => {
        const rowData = [
          {
            rowSpan: 2,
            styles: { halign: 'center' },
            content: y,
          },
          'Manhã', // Coluna para "Manhã"
        ];
        const rowDataTarde = ['Tarde'];

        houses.forEach((house) => {
          let totalBDJmanha = 0;
          let totalKGmanha = 0;
          let totalBDJtarde = 0;
          let totalKGtarde = 0;
          harvests.forEach((harvest) => {
            const harvestDate = parseFloat(
              harvest.harvest_date.substring(0, 4)
            );
            if (harvestDate === year && house.id === harvest.houses.id) {
              if (harvest.shift === 'manhã') {
                totalBDJmanha += harvest.harvest_quantity_plate;
                totalKGmanha += harvest.harvest_quantity_kg;
              }
              if (harvest.shift === 'tarde') {
                totalBDJtarde += harvest.harvest_quantity_plate;
                totalKGtarde += harvest.harvest_quantity_kg;
              }
            }
          });
          rowData.push(totalBDJmanha);
          rowData.push(totalKGmanha);
          rowDataTarde.push(totalBDJtarde);
          rowDataTarde.push(totalKGtarde);
        });

        tableData3.push(rowData);
        tableData3.push(rowDataTarde); // Coluna para "Tarde"
      });

      doc.autoTable({
        head: headData, // Cabeçalho da tabela
        body: tableData3,
        startY: tableY3,
        theme: 'plain',
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 5 : 7,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        headStyles: {
          valign: 'middle',
          halign: 'center',
          fontSize: houses.length >= 8 ? 6 : 8,
          fontStyle: 'bold',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        columnStyles: {
          0: { cellWidth: 15 }, // Defina a largura da primeira coluna (DATA)
          1: { cellWidth: 15 }, // Defina a largura da segunda coluna (TURNO)
        },
      });

      return doc;
    },

    async addTableDayPDF(doc, harvests, houses, day, month, year) {
      // const largura = 190; // Largura da borda
      const posicaoAtual = 90; // Posição atual do cursor

      // const alturaTotal = 290; // Altura total da tabela
      // const espacoRestante = alturaTotal - posicaoAtual; // Espaço restante para a tabela
      doc.setLineWidth(0.5);

      // Adicionar o retângulo ao documento com a cor especificada
      doc.setDrawColor(182, 182, 182);
      // doc.rect(10, posicaoAtual, largura, espacoRestante); // Desenhar o retângulo

      const tableData = [['Bandeja', 'Quilos'], []];

      const totalKG = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_kg,
        0
      );

      const totalBandejas = harvests.reduce(
        (acc, harvest) => acc + harvest.harvest_quantity_plate,
        0
      );

      tableData[1].push(totalBandejas, totalKG);

      const tableY = posicaoAtual + 5; // Posição Y da tabela

      // Tabela de dados gerais
      // doc.setFont('Inter-SemiBold');
      // doc.setFontSize(12);
      // const text = 'Dados Gerais';
      // doc.text(15, posicaoAtual + 7, text);

      doc.autoTable({
        head: [['SALDO DIÁRIO']],
        startY: tableY,
        theme: 'plain',
        headStyles: {
          valign: 'middle',
          halign: 'center',
          font: 'Inter-SemiBold',
          fontSize: 10,
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        tableWidth: 30,
      });

      doc.autoTable({
        head: [tableData[0]], // Cabeçalho da tabela (em um array)
        body: tableData.slice(1), // Dados da tabela (excluindo o cabeçalho)
        startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
        theme: 'plain', // Estilo da tabela (opcional)
        headStyles: {
          valign: 'middle',
          halign: 'center',
          font: 'Inter-Medium',
          fontSize: 12,
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
        },
        bodyStyles: {
          valign: 'middle',
          halign: 'center',
          lineWidth: 0.4,
          lineColor: [182, 182, 182],
          minCellHeight: 30, // Altura mínima das células do cabeçalho
          cellWidth: 90,
        },
        tableWidth: 180,
      });

      const nomeMonth = new Date(year, month - 1, 1)
        .toLocaleString('pt-br', {
          month: 'long',
        })
        .substring(0, 3)
        .toUpperCase();

      const numDia = day < 10 ? `0${day} ${nomeMonth}` : `${day} ${nomeMonth}`;

      // Tabela das casas diarias
      const maxCasasPorTabela = 3;
      const housesChunks = [];
      for (let i = 0; i < houses.length; i += maxCasasPorTabela) {
        housesChunks.push(houses.slice(i, i + maxCasasPorTabela));
      }

      housesChunks.forEach((housesChunk) => {
        const tableData2 = [[], [], []];

        housesChunk.forEach((house) => {
          const casa = {
            content: `${house.house_name}`,
            colSpan: 2,
            styles: { halign: 'center' },
          };

          const valorBDJ = harvests.reduce((acc, harvest) => {
            if (harvest.houses.id === house.id) {
              return acc + harvest.harvest_quantity_plate;
            }
            return acc;
          }, 0);

          const valorKG = harvests.reduce((acc, harvest) => {
            if (harvest.houses.id === house.id) {
              return acc + harvest.harvest_quantity_kg;
            }
            return acc;
          }, 0);
          tableData2[0].push(casa);
          tableData2[1].push('Bandeja', 'Quilos');
          tableData2[2].push(valorBDJ, valorKG);
        });

        // Crie uma nova tabela
        doc.autoTable({
          head: [[`${numDia}`]],
          startY: doc.lastAutoTable.finalY + 10,
          theme: 'plain',
          headStyles: {
            valign: 'middle',
            halign: 'center',
            fontSize: 7,
            fontStyle: 'bold',
            lineWidth: 0.4,
            lineColor: [182, 182, 182],
          },
          tableWidth: 20,
        });

        // Crie a tabela de dados da nova página
        doc.autoTable({
          head: [], // Cabeçalho vazio para reservar espaço
          body: tableData2, // Dados da tabela
          startY: doc.lastAutoTable.finalY, // Posição inicial da tabela no PDF
          theme: 'plain', // Estilo da tabela (opcional)
          bodyStyles: {
            valign: 'middle',
            halign: 'center',
            fontSize: 6,
            fontStyle: 'bold',
            lineWidth: 0.4,
            lineColor: [182, 182, 182],
            cellWidth: 'auto',
            minCellHeight: 10,
          },
          tableWidth: 180,
        });
      });
      return doc;
    },

    async addTitlePDF(doc, title, subtitle) {
      // Define o texto que você deseja centralizar
      let text = title;

      // Define a cor do texto
      doc.setTextColor('#2C2C2C');

      // Define a fonte e o tamanho do texto
      doc.setFontSize(56);
      doc.setFont('Inter-Bold');

      // Obtém a largura do texto
      let textWidth = doc.getTextWidth(text);

      // Obtém a largura da página
      let pageWidth = doc.internal.pageSize.getWidth();

      // Calcula a posição x do texto
      let textX = (pageWidth - textWidth) / 2;

      // Adiciona o texto centralizado à página
      doc.text(textX, 70, text);

      text = subtitle;
      doc.setFontSize(24);
      doc.setFont('Inter-Regular');

      textWidth = doc.getTextWidth(text);
      pageWidth = doc.internal.pageSize.getWidth();
      textX = (pageWidth - textWidth) / 2;

      doc.text(textX, 80, text);

      return doc;
    },
  },
};
